// Query-string flags such as ?joinSettings=1 or ?setup=1.
//
// app/router.options.ts parses the query with the Crud parseQuery (parseNumbers), so a direct load gives the number
// 1 while an in-app push of {flag: '1'} gives the string: compare as strings (R8 NM3).
//
// A flag that opens a dialog must not open it during hydration: Vuetify's overlay throws "Cannot read properties of
// undefined (reading 'classList')" and the page becomes a 500 (audit N18, R10 NH1). Start the dialog closed and open
// it from onMounted through whenHydrated.

/** Whether ?key=value is on the route, whatever type the router parsed it into. */
export function queryFlag(query, key, value = '1') {
    const v = query?.[key];
    if (v === undefined || v === null) return false;
    return String(Array.isArray(v) ? v[0] : v) === String(value);
}

/**
 * Runs fn once, when Nuxt has finished hydrating (or after `max` ms whatever happens). It polls the hydrating flag on
 * plain timers: onNuxtReady (app:suspense:resolve, then requestIdleCallback) never called back on a direct load of
 * the summary, so the switch-on never started (R6 NM3). A dialog opened during hydration throws in Vuetify's scroll
 * strategy, which is why it waits at all.
 */
export function whenHydrated(isHydrating, fn, {interval = 50, max = 3000, setTimer = setTimeout} = {}) {
    let waited = 0;
    let ran = false;
    const tick = () => {
        if (ran) return;
        if (!isHydrating() || waited >= max) {
            ran = true;
            fn();
            return;
        }
        waited += interval;
        setTimer(tick, interval);
    };
    setTimer(tick, 0);
}
